import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-module-disabled',
  templateUrl: './module-disabled.component.html',
  styleUrls: ['./module-disabled.component.scss']
})
export class ModuleDisabledComponent implements OnInit {
  private static readonly SUPPORT_PHONE = '5548991250397';
  private static readonly SUPPORT_MESSAGE =
    'Olá! Gostaria de habilitar um módulo da Easymarine para a minha marina.';

  parentLabel: string;
  moduleLabel: string;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      this.parentLabel = params.get('parent') || '';
      this.moduleLabel = params.get('module') || '';
    });
  }

  openWhatsappSupport(): void {
    const url = `https://wa.me/${ModuleDisabledComponent.SUPPORT_PHONE}`
      + `?text=${encodeURIComponent(ModuleDisabledComponent.SUPPORT_MESSAGE)}`;
    window.open(url, '_blank');
  }
}
